// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".saledetail-dialog[data-v-63b90c2f] {\n  height: 80%;\n}", ""]);
// Exports
module.exports = exports;
